<!--page starts-->
<section class="page-wrapper">
   <div class="ashton-hero-top-clubsponsorship">
      <div class="container">
         <div class="ashton-hero-top-clubsponsorship-detail">
            <h2>We're delighted you're interested in sponsoring Ashton United FC</h2>
         </div>
      </div>
      <div class="ashton-hero-top-clubsponsorship-overlay"></div>
   </div>
   <div class="ashton-hero-shop-section">
      <div class="container">
         <div class="ashton-hero-shop-detail">
            <div class="shop-cart">
               <a href="#"><img src="assets/images/shopping-cart.svg"></a>
            </div>
            <div class="red-titel">SHOP</div>
            <div class="ashton-hero-shop-detail-inner">
               <div class="ashton-hero-shop-detail-box">
                  <div class="ashton-hero-shop-image">
                     <img [src]="producttSingle?.image" alt="shop-one">
                  </div>
               </div>
               <div class="ashton-hero-shop-detail-box-content">
                  <div class="ashton-hero-shop-content">
                     <div class="ashton-hero-shop-content-left">
                        <h3>{{producttSingle?.title}}</h3>
                        <p>£ {{producttSingle?.min_amount}}.00</p>
                     </div>
                     <div class="ashton-hero-shop-content-center">
                        <div class="ashton-hero-shop-content-center-box" *ngFor="let pro of producttSingle?.product">
                           <div class="ashton-hero-shop-name">
                              <td>
                                 <p><span class="images"><img src="assets/images/adult-ic.svg"></span><span
                                       class="name">{{pro?.type}}</span></p>
                              </td>
                           </div>
                           <div class="ashton-number-box">
                              <table>
                                 <tr *ngFor="let psize of pro?.size">
                                    <td class="tshirt-size">
                                       <p>{{psize?.size}}</p>
                                    </td>
                                    <td class="price-box-detail">
                                       <p>£{{psize?.amount}}.00</p>
                                    </td>
                                    <td class="select-box-main">
                                       <div class="product-quantity">
                                          <div class="product-quantity-box">
                                             <input data-min="0" id="quantity{{psize?.product_size_master_id}}" name="quantity" readonly="true" type="text" value="0">
                                             <input data-min="0" id="product_master_id{{psize?.product_size_master_id}}" name="product_master_id" readonly="true" type="hidden" value="{{psize?.product_master_id}}">
                                             <input data-min="0" hidden id="price{{psize?.product_size_master_id}}" name="price" readonly="true" type="text" value="{{psize?.amount}}">
                                             <input data-min="0" id="product_size_id{{psize?.product_size_master_id}}" name="product_size_id" readonly="true" type="hidden" value="{{psize?.product_size_id}}">
                                             <div class="quantity-selectors-container">
                                                <div class="quantity-selectors">
                                                   <button id="{{psize?.product_size_master_id}}" class="increment-quantity" type="button" data-direction="1"><span>+</span></button>
                                                   <button id="{{psize?.product_size_master_id}}" data-id="{{psize?.product_size_master_id}}" class="decrement-quantity" type="button" data-direction="-1"><span>−</span></button>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!-- <tr>
                                    <td class="tshirt-size">
                                       <p>s</p>
                                    </td>
                                    <td class="price-box-detail">
                                       <p>£50.00</p>
                                    </td>
                                    <td class="select-box-main">
                                       <div class="product-quantity">
                                          <div class="product-quantity-box">
                                             <input name="quantity" readonly="true" type="text" value="0">
                                             <input name="price" readonly="true" type="text" value="">
                                             <div class="quantity-selectors-container">
                                                <div class="quantity-selectors"><button class="increment-quantity"
                                                      type="button"><span>+</span></button><button
                                                      class="decrement-quantity" type="button"><span>−</span></button>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr> -->
                              </table>
                           </div>
                        </div>
                     </div>
                     <div class="ashton-hero-shop-content-btn">
                        <a (click)="add_to_cart()" id="addtocart" class="show">Add To Cart</a>
                        <a routerLink="/checkout" id="gototcart" class="hidden">Go To Cart</a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section><!-- page ends -->